import React from "react";
import { COLORS } from "../myDashboardConstants";

/* These four card wrappers are nearly identical (same header markup) but each applies
 * a slightly different body class/style, matching the original inline definitions
 * exactly so no visual output changes. */

export function SectionCard({
  title,
  subtitle,
  icon,
  accent = COLORS.primary,
  action,
  className = "",
  bodyStyle,
  children,
}) {
  return (
    <div className={`sd-card h-100 ${className}`}>
      {(title || action || icon) && (
        <div className="sd-card-head">
          <div className="sd-card-head-left">
            <div>
              {title && <div className="sd-card-title">{title}</div>}
              {subtitle && <div className="sd-card-subtitle">{subtitle}</div>}
            </div>
          </div>
          <div className="sd-card-head-right">
            {action && <div>{action}</div>}
            {icon && (
              <span
                className="sd-card-head-icon"
                style={{ background: `${accent}17`, color: accent }}
              >
                {icon}
              </span>
            )}
          </div>
        </div>
      )}
      <div className="sd-card-body" style={bodyStyle}>
        {children}
      </div>
    </div>
  );
}

export function SectionCard1({
  title,
  subtitle,
  icon,
  accent = COLORS.primary,
  action,
  className = "",
  bodyStyle,
  children,
}) {
  return (
    <div className={`sd-card h-100 ${className}`}>
      {(title || action || icon) && (
        <div className="sd-card-head">
          <div className="sd-card-head-left">
            <div>
              {title && <div className="sd-card-title">{title}</div>}
              {subtitle && <div className="sd-card-subtitle">{subtitle}</div>}
            </div>
          </div>
          <div className="sd-card-head-right">
            {action && <div>{action}</div>}
            {icon && (
              <span
                className="sd-card-head-icon"
                style={{ background: `${accent}17`, color: accent }}
              >
                {icon}
              </span>
            )}
          </div>
        </div>
      )}
      <div className="sd-card1-body" style={bodyStyle}>
        {children}
      </div>
    </div>
  );
}

export function SectionCard2({
  title,
  subtitle,
  icon,
  accent = COLORS.primary,
  action,
  className = "",
  bodyStyle,
  children,
}) {
  return (
    <div className={`sd-card h-100 ${className}`}>
      {(title || action || icon) && (
        <div className="sd-card-head">
          <div className="sd-card-head-left">
            <div>
              {title && <div className="sd-card-title">{title}</div>}
              {subtitle && <div className="sd-card-subtitle">{subtitle}</div>}
            </div>
          </div>
          <div className="sd-card-head-right">
            {action && <div>{action}</div>}
            {icon && (
              <span
                className="sd-card-head-icon"
                style={{ background: `${accent}17`, color: accent }}
              >
                {icon}
              </span>
            )}
          </div>
        </div>
      )}
      <div className="sd-card-body1" style={bodyStyle}>
        {children}
      </div>
    </div>
  );
}

export function SectionCard3({
  title,
  subtitle,
  icon,
  accent = COLORS.primary,
  action,
  className = "",
  bodyStyle,
  children,
}) {
  return (
    <div className={`sd-card h-100 ${className}`}>
      {(title || action || icon) && (
        <div className="sd-card-head">
          <div className="sd-card-head-left">
            <div>
              {title && <div className="sd-card-title">{title}</div>}
              {subtitle && <div className="sd-card-subtitle">{subtitle}</div>}
            </div>
          </div>
          <div className="sd-card-head-right">
            {action && <div>{action}</div>}
            {icon && (
              <span
                className="sd-card-head-icon"
                style={{ background: `${accent}17`, color: accent }}
              >
                {icon}
              </span>
            )}
          </div>
        </div>
      )}
      <div style={bodyStyle}>{children}</div>
    </div>
  );
}
